/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    import NetworkInterface = Models.NetworkInterface;

    export interface IPortMapping {
        ruleNumber: number;
        label: string;
        protocol: string;
        originalSourceNic: NetworkInterface;
        originalDestinationNic: NetworkInterface;
        originalDestinationPorts: string;
        translatedSourceNic: NetworkInterface;
        translatedDestinationNic: NetworkInterface;
        translatedDestinationPorts: string;
    }

    export class PortMapping implements IPortMapping {
        public ruleNumber: number;
        public label: string;
        public protocol: string;
        public originalSourceNic: NetworkInterface;
        public originalDestinationNic: NetworkInterface;
        public originalDestinationPorts: string;
        public translatedSourceNic: NetworkInterface;
        public translatedDestinationNic: NetworkInterface;
        public translatedDestinationPorts: string;

        public static compare(map1: Models.IPortMapping, map2: Models.IPortMapping): number {
            if (map1.ruleNumber <= map2.ruleNumber) {
                return -1;
            } else {
                return 1;
            }
        }

        public static copy(mapping: PortMapping): PortMapping {
            let copy: PortMapping = new PortMapping();
            copy.ruleNumber = mapping.ruleNumber;
            copy.label = mapping.label;
            copy.protocol = mapping.protocol;
            copy.originalSourceNic = mapping.originalSourceNic;
            copy.originalDestinationNic = mapping.originalDestinationNic;
            copy.originalDestinationPorts = mapping.originalDestinationPorts;
            copy.translatedSourceNic = mapping.translatedSourceNic;
            copy.translatedDestinationNic = mapping.translatedDestinationNic;
            copy.translatedDestinationPorts = mapping.translatedDestinationPorts;
            return copy;
        }

        public static Empty(): PortMapping {
            return new PortMapping();
        }

        constructor() {
            // empty constructor
            this.ruleNumber = 1;
            this.label = '';
            this.protocol = '';
            this.originalDestinationPorts = '';
            this.translatedDestinationPorts = '';
        }
    }
}